import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { Select, MenuItem, FormControl, FormHelperText } from '@mui/material';

class AlpineSelect extends Component {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };

        this.onChange = this.onChange.bind(this);
    }

    componentWillMount() {
        if (!this.state.value && this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
            const selectedValue = this.props.defaultValue;
            let item = this.props.options.filter((item) => item.value == selectedValue)[0];
            this.props.dispatch({ type: types.FORM_INPUT, value: selectedValue, name: this.props.name });
            this.props.dispatch({ type: types.FORM_INPUT, value: item.text, name: `${this.props.name}Text` });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.state.value) {
            this.setState({ value: newProps.value });
        }

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    menuItems(options) {
        return options.map((option) => (
            <MenuItem
                key={option.value}
                value={option.value}
                primaryText={<div className="my-multi-lines-item">{option.text}</div>}></MenuItem>
        ));
    }

    onChange = (event, index, value) => {
        const p = this.props;
        this.setState({ value });
        this.props.dispatch({ type: types.FORM_INPUT, value, name: p.name });
        this.props.dispatch({ type: types.FORM_INPUT, value: p.options[index].text, name: `${p.name}Text` });
        if (this.props.onChange != undefined) {
            this.props.onChange(value)
        }
    }

    render() {
        const p = this.props;
        const e = this.state && this.state.error;
        const value = this.state && this.state.value;
        const { options, className, error, dispatch, defaultValue, ...textProps } = { ...p };
        if (!p.options) return null;

        return (<div className={p.className || "form-group"}>
            {/* <SelectField
                {...textProps}
                onChange={this.onChange}
                className={this.className}
                errorText={e && (value === undefined || value === '' || value == null) ? p.error : ''} >
                {this.menuItems(p.options)}
            </SelectField> */}
            <FormControl error={e && (value === undefined || value === '' || value == null)}>
                <Select
                    {...textProps}
                    value={value}
                    onChange={this.onChange}
                    className={this.className}
                >
                    {this.menuItems(p.options)}
                </Select>
                {e && (
                    <FormHelperText>
                        {value === undefined || value === '' || value == null ? p.error : ''}
                    </FormHelperText>
                )}
            </FormControl>
        </div>);
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name]
    };
};

export default connect(mapStateToProps)(AlpineSelect);